import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { getFormattedValue } from "../../../../utils/previewValueFormatterUtils";
import { PreviewCardLayout } from "./PreviewCardLayout";

interface InvitationLinkCardProps {
  params: Record<string, string>;
  url: string;
}

export const InvitationLinkCard = ({
  params,
  url,
}: InvitationLinkCardProps) => {
  const INVITATION_LINK_FIELDS = {
    name: {
      label: t("settings.invite_members.details_tab.member_details.name"),
      type: "string",
    },
  };

  return (
    <PreviewCardLayout
      title={t("help_widget.copilot.preview_cards.invitation_link_card_title")}
      url={url}
    >
      <ul className="flex flex-col leading-5">
        {Object.entries(INVITATION_LINK_FIELDS).map(
          ([key, keyProps]) =>
            params[key] && (
              <li key={key} className="!pb-0">
                <Typography.BodySm color="text-dark">
                  <strong>{keyProps.label}:</strong>{" "}
                  {getFormattedValue(params[key], keyProps.type)}
                </Typography.BodySm>
              </li>
            ),
        )}
      </ul>
    </PreviewCardLayout>
  );
};
